import { rpcDefinition } from "@redotech/redo-merchant-inventory-rpc/definition";
import type { ClientOptions } from "@redotech/rpc/client";
import { createRpcContractClient } from "@redotech/rpc/client";
import type { RedoInventoryRpcContract } from "./rpc-contract.generated";

export function createRedoInventoryRpcClient(
  options: ClientOptions<RedoInventoryRpcContract>,
): RedoInventoryRpcContract {
  return createRpcContractClient<RedoInventoryRpcContract>(
    rpcDefinition,
    options,
  );
}

export type RedoInventoryRpcClient = RedoInventoryRpcContract;
